<template>
  <div class='loginBox'>
    <p class="logoBox">
      <img alt="" class="logo" src="@/assets/img/logo.png">
    </p>
    <div class="inputBox">
      <van-field v-model="text" :border="false" :label="$t('邮箱')" :placeholder="$t('请输入邮箱')" />
      <van-field v-model="password" :border="false" :label="$t('密码')" :placeholder="$t('请输入登录密码')" type="password" />
      <van-field v-model="localeTxt" :border="false" :label="$t('语言')" :placeholder="$t('请选择语言')" readonly
        right-icon="arrow-down" @click="checkLocale" />
    </div>
    <div class="btn" @click="loginBtn">{{ $t('登录') }}</div>
    <!-- TP钱包登录按钮 -->
    <div class="btn tpWalletBtn" @click="tpWalletLogin">{{ $t('TP钱包登录') }}</div>
    <div class="operate">
      <span class="forgotPass" @click="router('/download')">{{ $t('下载') }}</span>
      <span class="forgotPass" @click="router('/password')">{{ $t('忘记密码') }}</span>
    </div>
    <div class="protocol">
      <img v-show="!check" alt="" class="radioImg" src="@/assets/img/check2.png" @click="check = !check">
      <img v-show="check" alt="" class="radioImg" src="@/assets/img/check1.png" @click="check = !check">
      <div class="txt">
        {{ $t('已阅读并同意') }}
        <span class="tc1" @click="router('/agreement', { type: 1 })">{{ $t('服务协议') }}</span>
        {{ $t('和 ') }}
        <span class="tc1" @click="router('/agreement', { type: 2 })">{{ $t('隐私政策') }}</span>
      </div>
    </div>
    
    <!-- Google验证器模态框 -->
    <van-popup v-model="showGoogleAuthModal" :close-on-click-overlay="false" position="center" round>
      <div class="google-auth-modal">
        <div class="modal-header">
          <h3>{{ $t('Google验证') }}</h3>
        </div>
        <div class="modal-body">
          <p>{{ $t('请输入Google验证器生成的6位动态码') }}</p>
          <van-field 
            v-model="googleAuthCode" 
            :placeholder="$t('6位动态码')" 
            type="number" 
            maxlength="6"
            class="auth-code-input"
          />
        </div>
        <div class="modal-footer">
          <van-button type="default" @click="cancelGoogleAuth" class="cancel-btn">{{ $t('取消') }}</van-button>
          <van-button type="primary" @click="verifyGoogleAuth" :disabled="googleAuthCode.length !== 6" class="confirm-btn">{{ $t('验证') }}</van-button>
        </div>
      </div>
    </van-popup>
    
    <van-popup v-model="fieldShow" :close-on-click-overlay="false" position="bottom">
      <van-picker :columns="columns" :title="$t('选择语言')" show-toolbar @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
  </div>
</template>

<script>
import tpwallet from '../../../mixin/tpwallet'

export default {
  mixins: [tpwallet],
  data() {
    return {
      text: "",
      password: "",
      check: false,
      // 语言相关略…
      showGoogleAuthModal: false,
      googleAuthCode: '',
      loginResponse: null,
    }
  },
  mounted() {
    // 生命周期钩子要放这里，之前写在 methods 根本不会执行
    if (this.isTPWallet()) {
      this.$dialog.confirm({
        title: 'TP钱包登录',
        message: '检测到您在TP钱包内打开，是否使用TP钱包登录？',
      }).then(() => this.tpWalletLogin());
    }
  },
  watch: {
    googleAuthCode(v){ this.googleAuthCode=(v||'').replace(/\D/g,'').slice(0,6); }
  },
  methods: {
    // TP钱包登录方法
    async tpWalletLogin() {
      try {
        if (!this.isTPWallet()) {
          return this.$toast('请在TP钱包内打开应用');
        }

        this.$toast.loading({ message: '正在连接钱包...', duration: 0 });

        // 连接钱包
        const address = await this.connectWallet();

        // 统一的时间戳 & 随机 nonce（一起写进 message，并且单独传给后端）
        const timestamp = Math.floor(Date.now() / 1000); // 如果后端要毫秒，改成 Date.now()
        const nonce = Math.random().toString(36).slice(2, 10);

        // 明文建议包含地址、时间戳、nonce，防重放
        const message =
          `Login verification\n` +
          `Address: ${address}\n` +
          `Timestamp: ${timestamp}\n` +
          `Nonce: ${nonce}`;

        // 签名（自动适配 EVM / TRON）
        const { signature, chain, method } = await this.signMessageUnified(message);

        this.$toast.clear();

        // ✅ 同时把 timestamp/nonce 作为独立字段传给后端
        this.$post({
          url: `/login/tpWallet`,
          loading: true,
          noToken: true,
          data: {
            wallet_address: address,
            signature,
            message,     // 让后端用这个明文做验签
            chain,       // 'evm' | 'tron'
            method,      // 'personal_sign' | 'eth_sign' | 'tron_sign_v2'
            timestamp,   // 🔴 必填：后端要的字段
            nonce        // 建议也带上，用于一次性校验
          },
          success: (res) => this.handleLoginSuccess(res),
          tip: (res) => this.$toast(res.message || this.$t('TP钱包登录失败'))
        });
      } catch (error) {
        this.$toast.clear();
        console.error('TP wallet login error:', error);
        this.$toast(error?.message || 'TP钱包登录失败，请重试');
      }
    },
    // 第一步：账号密码登录
    loginBtn() {
      if (!this.text) return this.$toast(this.$t("请输入邮箱"))
      if (!this.password) return this.$toast(this.$t("请输入登录密码"))
      if (!this.check) return this.$toast(this.$t("请同意服务协议与隐私政策"))

      this.$post({
        url: `/login`,
        loading: true,
        noToken: true, // 首次登录不带 token
        data: { account: this.text, password: this.password },
        success: (res) => {
          // res 结构：{ code, status, message, data: {...} }
          // 登录接口可能直接返回最终 token，也可能返回预登录 token + totp_required
          const payload = res && res.data ? res.data : {};

          // 先把 token（预登录或最终）存上，便于后续请求
          const preOrFinalToken = payload.token || (payload.user && payload.user.token);
          if (preOrFinalToken) {
            this.local.set("token", preOrFinalToken);
            // 如果你要给 axios 也带上：
            this.$axios && (this.$axios.defaults.headers.common['Authorization'] = `Bearer ${preOrFinalToken}`);
          }

          const needTotp = payload.totp_required == 1 
                        || (payload.user && payload.user.is_google_auth_enabled === true);

          if (needTotp) {
            this.loginResponse = res;
            this.showGoogleAuthModal = true;
          } else {
            this.handleLoginSuccess(res); // 直接走成功
          }
        },
        tip: (res)=> this.$toast(res.message || this.$t('登录失败')),
      })
    },

    // 第二步：TOTP 验证
    verifyGoogleAuth() {
      if (this.googleAuthCode.length !== 6) {
        return this.$toast(this.$t("请输入6位验证码"));
      }
      this.$post({
        url: `/member/verifyGoogleAuth`, // 你当前就在用这个
        loading: true,
        // 不要 noToken，这样拦截器会自动把 Authorization: Bearer <token> 带上
        data: {
          // 你的后端目前版本需要这三项就保留（如果改成预登录 token 模式，只传 code 即可）
          account: this.text,
          password: this.password,
          code: this.googleAuthCode
        },
        success: (res) => {
          // 这里返回最终 token
          this.showGoogleAuthModal = false;
          this.googleAuthCode = '';
          this.handleLoginSuccess(res);
        },
        tip: (res)=> this.$toast(res.message || this.$t('验证码错误')),
      })
    },

    // 登陆成功后的统一处理 + 跳转
    handleLoginSuccess(res) {
      const payload = res && res.data ? res.data : {};
      const token   = payload.token || (payload.user && payload.user.token);
      if (token) {
        this.local.set("token", token);
        this.$axios && (this.$axios.defaults.headers.common['Authorization'] = `Bearer ${token}`);
      }
      if (payload.user) {
        this.local.set("user", JSON.stringify(payload.user));
      }

      // 修复点：不要无保护地调用 this.$http.setToken
      try {
        this.$http && this.$http.setToken && this.$http.setToken(token);
      } catch(e) {
        // 忽略
      }

      // 这里直接跳转（先用 router，没有就 fallback）
      if (this.$router && this.$router.replace) {
        this.$router.replace("/");
      } else {
        window.location.href = "/";
      }
    },

    cancelGoogleAuth(){
      this.showGoogleAuthModal = false;
      this.googleAuthCode = '';
      this.loginResponse = null;
    },
  }
}
</script>

<style lang='less' scoped>
  .loginBox {
    width: 100%;
    min-height: 100vh;
    padding: 30px;
    background-image: url("../../../assets/img/login.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .logoBox {
      text-align: center;
      margin-bottom: 20px;
      .logo {
        width: 122px;
        height: 122px;
      }
    }
    .inputBox {
      display: flex;
      flex-direction: column;
      gap: 20px 0;
      ::v-deep .van-field {
        background-color: #000000;
        border-radius: 7px;
        .van-field__label {
          color: #ffffff;
        }
        .van-field__value {
          .van-field__body {
            .van-field__control {
              color: #ffffff;
            }
          }
        }
      }
    }
    .btn {
      padding: 10px 0;
      background-color: #cbac7b;
      border-radius: 8px;
      margin-top: 60px;
      text-align: center;
      font-size: 15px;
      font-weight: bold;
    }
    
    // TP钱包登录按钮样式
    .tpWalletBtn {
      margin-top: 20px;
      background-color: #4285f4;
    }
    .operate {
      display: flex;
      justify-content: space-between;
      margin-top: 15px;
      .forgotPass {
        font-size: 12px;
        color: #999999;
      }
    }
    .protocol {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0 10px;
      margin-top: 100px;
      .radioImg {
        width: 15px;
        height: 15px;
      }
      .txt {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        color: #999999;
        .tc1 {
          margin: 0 5px;
          color: #adadad;
        }
      }
    }
  }
  
  // Google验证器模态框样式
  .google-auth-modal {
    width: 300px;
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    
    .modal-header {
      text-align: center;
      margin-bottom: 15px;
      
      h3 {
        margin: 0;
        color: #333;
      }
    }
    
    .modal-body {
      text-align: center;
      margin-bottom: 20px;
      
      p {
        margin: 0 0 15px 0;
        color: #666;
        font-size: 14px;
      }
      
      .auth-code-input {
        ::v-deep .van-field__control {
          text-align: center;
          font-size: 18px;
          letter-spacing: 2px;
        }
      }
    }
    
    .modal-footer {
      display: flex;
      justify-content: space-between;
      
      .cancel-btn {
        flex: 1;
        margin-right: 10px;
      }
      
      .confirm-btn {
        flex: 1;
        margin-left: 10px;
      }
    }
  }
</style>
